// extracted by mini-css-extract-plugin
export default {"preview":"FilePreview_preview__QbYsJ","small":"FilePreview_small__oRCiw"};